// extracted by mini-css-extract-plugin
export default {"notice":"PCRSSchemeSkippedNotice_notice__S5XAs","icon":"PCRSSchemeSkippedNotice_icon__Kgklh","text":"PCRSSchemeSkippedNotice_text__05LGu"};